<template>
     <footer>
         <div class="footer-section">
             <div class="icons-netflix-social">
                 <img src="../assets/facebook-square-brands.svg">
                 <img src="../assets/instagram-brands.svg">
                 <img src="../assets/twitter-brands.svg">
                 <img src="../assets/youtube-brands.svg">
             </div>
             <p>© 1997-2021 Netflix, </p>
         </div>
     </footer>
</template>

<script>
export default {
    
}
</script>


<style scoped>
footer{
    width:100%;
    margin-top: -15vw;
}
  .footer-section{
      width:calc(100% - 10vw);
      margin-left: 5vw;
  }
.footer-section p{
    color:#808080;
    margin-top: 1vw;
}
.icons-netflix-social img{
  height: 2vw;
  width: 2vw;
  margin-left: 1vw;
}
</style>